import { tooltipClasses } from "@mui/material";
import { createElement } from "react";

import { NoMaxWidthTooltip } from "@/pages/DriverStatus.tsx/components/DriverStatusColumnTooltip";
import { CommonStatusItem } from "@/types/global";

import HotelStatusTooltip from "../../arrival/components/table/components/HotelStatusTooltip";

function HotelClinicArrivalSectionTooltip(props: CommonStatusItem & { label: string }) {
    return (
        <div className="flex shrink-0 items-center text-sm">
            <NoMaxWidthTooltip
                arrow
                sx={{
                    [`& .${tooltipClasses.tooltip}`]: {
                        backgroundColor: "white",
                        border: "none",
                        padding: "0px !important",
                        fontSize: 11,
                        maxWidth: "300px !important",
                    },
                }}
                title={<HotelStatusTooltip status={props} />}
            >
                <div className="font-semibold text-slate-700 flex items-center gap-1">
                    {createElement(props.component(), { fontSize: 14 })} {props.label || ""}
                </div>
            </NoMaxWidthTooltip>
        </div>
    );
}
export default HotelClinicArrivalSectionTooltip;
